import React from "react";
import check from "../../assets/images/check.png";
import { Link } from "react-router-dom";
const LoginSuccess = () => {
  return (
    <div className="LoginArea">
      <div className="LoginBox" style={{ width: "30%" }}>
        <div className="LoginLeft text-center w-100">
          <figure>
            <img src={check} />
          </figure>
          <h2>Success</h2>
          <h6>
            Your password had been changed <br /> successfully
          </h6>
          <form>
            <Link to={"/login"} className="Button">
              Done
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginSuccess;
